import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';
setAutoFreeze(false); // 禁止凍結

const localModifyTour = JSON.parse(
  sessionStorage.getItem('custom-itinerary-modifyTour')
);

const initialState = {
  detailsData: localModifyTour?.detailsData || [],
  tourLength: localModifyTour?.tourLength || [],
  smallShowDay: localModifyTour?.smallShowDay || 0,
  tourLimit: localModifyTour?.tourLimit || 0,
  reset: localModifyTour?.reset || 0,
};

export const modifyTourSlice = createSlice({
  name: 'modifyTour',
  initialState,
  reducers: {
    modifyTourUpdate: (state, action) => {
      sessionStorage.setItem('custom-itinerary-modifyTour', JSON.stringify(action.payload));
      return action.payload;
    },
    modifyTourReset: () => {
      sessionStorage.removeItem('custom-itinerary-modifyTour');
      return {
        detailsData: [],
        tourLength: [],
        smallShowDay: 0,
        tourLimit: 0,
        reset: 0,
      };
    },
  },
});

/** 行程調整 */
export const modifyTourSelect = (state) => state.modifyTour;
export const { modifyTourUpdate, modifyTourReset } = modifyTourSlice.actions;
export default modifyTourSlice.reducer;
